import { z } from "zod";
import type { Game, Variation } from "./types";
export const ObserveInput = z
  .object({
    gameId: z.string().uuid(),
    variationId: z.string().uuid().nullable().optional(),
    ply: z.number().int().min(1).max(1000),
    historyKey: z
      .string()
      .regex(/^[a-f0-9]{64}$/)
      .optional(),
    requestId: z.string().uuid(),
  })
  .strict();
export type ObserveInput = z.infer<typeof ObserveInput>;
export const liveMode = (game: Game) =>
  game.coaching === "quiet" ||
  (game.coaching === "postgame" && game.result === "*")
    ? "off"
    : (game.liveReview ?? "mistakes");
export async function moveHistoryKey(
  record: Pick<Game | Variation, "initialFen" | "moves">,
  ply: number,
) {
  const source = `${record.initialFen}\n${record.moves.slice(0, ply).join(" ")}`;
  return Array.from(
    new Uint8Array(
      await crypto.subtle.digest("SHA-256", new TextEncoder().encode(source)),
    ),
    (v) => v.toString(16).padStart(2, "0"),
  ).join("");
}
